import { enCatalog } from './en/index.js';
import { roCatalog } from './ro/index.js';
export const CATALOGS = {
    en: enCatalog,
    ro: roCatalog,
};
